import * as types from "./actionTypes";

export const fetchTimesheetReportDropdowns = (payload) => ({
  type: types.FETCH_TIMESHEET_REPORT_DROPDOWNS_REQUEST,
  payload,
});

export const fetchTimesheetReportList = (payload) => ({
  type: types.FETCH_TIMESHEET_REPORT_LIST_REQUEST,
  payload,
});

export const fetchTimesheetTaskStatusReport = (payload) => ({
  type: types.FETCH_TIMESHEET_TASK_STATUS_REPORT_REQUEST,
  payload,
});

export const fetchTimesheetEmployeeTaskStatusReport = (payload) => ({
  type: types.FETCH_TIMESHEET_EMPLOYEE_TASK_STATUS_REPORT_REQUEST,
  payload,
});

export const resetTimesheetEmployeeTaskStatusReport = () => ({
  type: types.RESET_TIMESHEET_EMPLOYEE_TASK_STATUS_REPORT,
});

export const fetchTimesheetMonthlyReport = (payload) => ({
  type: types.FETCH_TIMESHEET_MONTHLY_REPORT_REQUEST,
  payload,
});

// Project Status Report
export const fetchProjectStatusReport = (payload) => ({
  type: types.FETCH_PROJECT_STATUS_REPORT_REQUEST,
  payload,
});

// Project Details Report
export const fetchProjectDetailsReport = (payload) => ({
  type: types.FETCH_PROJECT_DETAILS_REPORT_REQUEST,
  payload,
});

// Project Service Report
export const fetchProjectServiceReport = (payload) => ({
  type: types.FETCH_PROJECT_SERVICE_REPORT_REQUEST,
  payload,
});

// Module Tasks Report
export const fetchModuleTasksReport = (payload) => ({
  type: types.FETCH_MODULE_TASKS_REPORT_REQUEST,
  payload,
});

// Employee Details Report
export const fetchEmployeeDetailsReport = (payload) => ({
  type: types.FETCH_EMPLOYEE_DETAILS_REPORT_REQUEST,
  payload,
});

// Module Search Report
export const fetchModuleSearchReport = (payload) => ({
  type: types.FETCH_MODULE_SEARCH_REPORT_REQUEST,
  payload,
});

// Project Status List
export const fetchProjectStatusList = (payload) => ({
  type: types.FETCH_PROJECT_STATUS_LIST_REQUEST,
  payload,
});

// Project Client Details List
export const fetchProjectClientDetailsList = (payload) => ({
  type: types.FETCH_PROJECT_CLIENT_DETAILS_LIST_REQUEST,
  payload,
});

// Project Employee Details
export const fetchProjectEmployeeDetails = (payload) => ({
  type: types.FETCH_PROJECT_EMPLOYEE_DETAILS_REQUEST,
  payload,
});

// Project Client List
export const fetchProjectClientList = (payload) => ({
  type: types.FETCH_PROJECT_CLIENT_LIST_REQUEST,
  payload,
});

export const getprojectstatusdetails_export = (payload) => ({
  type: types.FETCH_PROJECT_STATUS_EXPORT_REQUEST,
  payload,
});